import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { SwitchComponent } from "@syncfusion/ej2-vue-buttons";
import { ref, watch } from "vue";

interface Props {
  modelValue?: boolean;
  placeholder?: string;
  disabled?: boolean;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*@__PURE__*/_defineComponent({
  __name: 'SogSwitch',
  props: {
    modelValue: { type: Boolean, default: undefined },
    placeholder: { default: undefined },
    disabled: { type: Boolean, default: false }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const emit = __emit;

const _value = ref(false);

/*
onMounted(()=>{
  _value.value = props.modelValue

})
*/

watch(
  props,
  () => {
    _value.value = props.modelValue;
  },
  { immediate: true }
);

function onChange() {
  emit("update:modelValue", _value?.value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("table", null, [
      _createElementVNode("tr", null, [
        _createElementVNode("td", null, _toDisplayString(__props.placeholder), 1),
        _createElementVNode("td", null, [
          _createVNode(_unref(SwitchComponent), {
            modelValue: _value.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_value).value = $event)),
            checked: _value.value,
            style: {"padding-top":"10px"},
            onChange: onChange
          }, null, 8, ["modelValue", "checked"])
        ])
      ])
    ])
  ]))
}
}

})